/*
 * @Author: shannyHuang
 * @Date: 2022-09-01 18:03:56
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-09-01 18:37:18
 * @FilePath: /wemeet-web-activity/src/components/labelTips/index.tsx
 */
import React, { ReactNode } from 'react';
import { Bubble, useClassNames } from '@tencent/tea-component';

interface LabelProps {
  tipText: ReactNode;
  labelText?: string;
  iconType?: 'info' | 'warning' | 'error';
  placement?:
    | 'top'
    | 'auto-start'
    | 'auto'
    | 'auto-end'
    | 'top-start'
    | 'top-end'
    | 'right-start'
    | 'right'
    | 'right-end'
    | 'bottom-end'
    | 'bottom'
    | 'bottom-start'
    | 'left-end'
    | 'left'
    | 'left-start';
}
const Label = (props: LabelProps) => {
  const { tipText, labelText, placement = 'bottom', iconType = 'info' } = props;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { Margin } = useClassNames();
  return (
    <>
      <span>{labelText}</span>
      {!!tipText && (
        <Bubble placement={placement} content={tipText} style={{ maxWidth: '340px' }}>
          <i className={`iconfont icon-info is-${iconType} ${Margin.Left['1n']}`}></i>
        </Bubble>
      )}
    </>
  );
};
export default Label;
